import store from "@redux/store";
import { COUNTRY, COUNTRY_CONFIG } from "@type/index";

export const footAndInches: COUNTRY_CONFIG<boolean> = {
  [COUNTRY.HK]: false,
  [COUNTRY.TW]: false
};

// inch conversion
export const heightFootFromTotalInch = (totalInch: number) =>
  Math.floor(totalInch / 12);
export const heightInchFromTotalInch = (totalInch: number) =>
  Math.floor(totalInch % 12);
export const heightFootInchFromTotalInch = (totalInch: number) => {
  const foot = heightFootFromTotalInch(totalInch);
  const inch = heightInchFromTotalInch(totalInch);
  return `${foot}′ ${inch}″`;
};

export const userHeight = (height: number): string => {
  const config = store.getState().config;
  const country = config.region as COUNTRY;
  if (footAndInches[country])
    return height === 0 ? "-′-″" : heightFootInchFromTotalInch(height);
  else return height === 0 ? "-" : height?.toString() ?? "-";
};

export const getSeoHeight = (height: number) => {
  const formattedHeight = userHeight(height);
  return formattedHeight.replace(/′/g, "'").replace(/″/g, '"');
};
